var React = require('react');

function Category (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m255.989 0-221.693 127.993v255.985l221.693 127.994 221.688-127.994v-255.985zm176.683 136.651-176.683 101.965-176.688-101.965 176.688-102.01zm-368.376 25.977 176.693 101.969v204.074l-176.693-102.013zm206.693 306.043v-204.074l176.688-101.968v204.03z"}));
}

Category.defaultProps = {"id":"Capa_1","enableBackground":"new 0 0 511.973 511.973","height":"512","viewBox":"0 0 511.973 511.973","width":"512"};

module.exports = Category;

Category.default = Category;
